<script>
  import { createEventDispatcher } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Carousel } from '@client/components/carousel';
  import { Icon } from '@client/components/icon';

  import { appStore } from '@client/stores/app';

  export let show = false;
  export let templates = [];

  const dispatch = createEventDispatcher();

  // Local to the modal: reset to the first template on every open ({#if show} remounts).
  let currentTemplateIndex = 0;

  $: zoom = $appStore.mobile ? '.5' : '.8';
</script>

{#if show}
  <Modal bind:isOpen={show} close={false} size="lg" fullscreen="lg">
    <ModalBody class="gallery-selection-modal">
      <button class="back" on:click={() => dispatch('back')}>
        <Icon name="arrow-left" />
        <span>{$format('label.BACK')}</span>
      </button>
      <button class="close" data-testid="close-modal" on:click={() => (show = false)}>
        <Icon name="x" />
      </button>
      <div>
        <h1>{$format('label.SIGNATURE_GALLERY')}</h1>
        <p>{$format('label.DESCRIPTION.SIGNATURE_GALLERY')}</p>
      </div>

      <div class="carousel-container">
        <Carousel items={templates} ride={false} bind:activeIndex={currentTemplateIndex} let:index let:item={template}>
          <div class="signature-block" data-testid="signature-template-{index}">
            <iframe
              tabindex="-1"
              style="width: 100%; height: {$appStore.mobile ? template.height / 1.5 : template.height}px;"
              scrolling="no"
              sandbox="allow-same-origin"
              title={template.name}
              srcdoc="<html><body><div style='transform: scale({zoom},{zoom}); transform-origin: 34px 0; -moz-transform:  scale({zoom},{zoom}); -moz-transform-origin: 34px 0;'>{template.html}</div></body></html>"
            />
          </div>
        </Carousel>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button
        id="modal-btn"
        color="primary"
        data-testid="use-template-btn"
        disabled={!templates.length}
        on:click={() => dispatch('use', templates[currentTemplateIndex])}
      >
        {$format('label.USE_THIS_TEMPLATE')}
      </Button>
    </ModalFooter>
  </Modal>
{/if}
